// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ab9bc6cafe5962be04e1","655":"5b8afaad64956dc30be7"}[chunkId] + ".js";
};